exports.isNumber = number => {
  if (
    number !== undefined &&
    number !== null &&
    number !== '' &&
    !number.startsWith(0)
  ) {
    // eslint-disable-next-line no-restricted-globals
    return !isNaN(number);
  }
  return false;
};

exports.isNumeric = number => {
  const regex = new RegExp('^[0-9]+$');
  return regex.test(number.trim());
};

exports.isAlphanumeric = number => {
  const regex = new RegExp('^[a-zA-Z0-9]+$');
  return regex.test(number.trim());
};

exports.isLengthSmsOk = number => {
  return number.length === 6;
};

exports.isMinLengthOk = string => {
  return string.length >= 6;
};

exports.isEmail = email => {
  return /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$/.test(
    email.trim().toLowerCase()
  );
};

exports.isEmpty = value => {
  return value.length <= 0;
};
